export const orgInternTranslations = {
  lv: {
    title: 'Visi praktikanti',
    description:
      'Visi šīs prakses vietas praktikanti neatkarīgi no tā, kuram prakses vadītājam tie piešķirti. Šis skats pieejams administratoriem.',
    search: 'Meklēt pēc vārda, izglītības iestādes, prakses…',
    supervisor: 'Prakses vadītājs',
    lastRecord: 'Pēdējais ieraksts',
    statuses: { 0: 'Aktīvās un gaidāmās prakses', 1: 'Gaidāmās prakses', 2: 'Visi praktikanti' },
    readOnly:
      'Bez aktīva abonementa pieejama tikai saraksta apskate. Meklēšana, filtri, kārtošana un darbības nav pieejamas. Rādītas aktīvās un gaidāmās prakses, arī tās, kas beigušās pēdējo 7 dienu laikā.',
    filterError: 'Neizdevās ielādēt filtru izvēles.',
    loading: 'Ielādē…',
    refineOptions: 'Redzamas pirmās 50 izvēles. Precizējiet meklēšanu, lai atrastu pārējās.',
    hours: '{{done}} no {{planned}} stundām',
    missingHours: 'Stundu dati nav pieejami',
    placements:
      'Katrs ieraksts ir praktikanta norīkojums pie viena prakses vadītāja. Praktikants ar vairākiem vadītājiem sarakstā var parādīties vairākas reizes.',
  },
  en: {
    title: 'All interns',
    description:
      'All interns at this workplace, regardless of their assigned supervisor. This view is available to administrators.',
    search: 'Search by name, educational institution, internship…',
    supervisor: 'Supervisor',
    lastRecord: 'Last entry',
    statuses: { 0: 'Active and upcoming internships', 1: 'Upcoming internships', 2: 'All interns' },
    readOnly:
      'Without an active subscription, this list is view-only. Search, filters, sorting and actions are unavailable. Active and upcoming internships are shown, including those that ended within the last 7 days.',
    filterError: 'Could not load filter options.',
    loading: 'Loading…',
    refineOptions: 'The first 50 options are shown. Refine your search to find others.',
    hours: '{{done}} of {{planned}} hours',
    missingHours: 'Hour data unavailable',
    placements:
      'Each row is an intern’s placement under one supervisor. An intern with several supervisors can appear more than once.',
  },
}
